"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdventureMetaUpdatedEventArgs = void 0;
const EventType_1 = require("../EventType");
class AdventureMetaUpdatedEventArgs {
    constructor(meta) {
        this.meta = meta;
        this.__type = EventType_1.EventType.AdventureMetaUpdated;
        this.__typeName = "AdventureMetaUpdated";
    }
}
exports.AdventureMetaUpdatedEventArgs = AdventureMetaUpdatedEventArgs;
